import FormattedMessage from 'I18n/components/FormattedMessage';
import { Heading, LayoutHorizontal, LayoutSpaceVertical, LayoutBox } from 'breeze-intelligence-kit';
import { MatchRatePropertiesGrid } from './MatchRatePropertiesGrid';
import { PanelHeader } from './PanelHeader';
import { SectionMatchRate } from './SectionMatchRate';
import { useDataTest } from './useDataTest/useDataTest';
import { DataTestError } from './DataTestError';
import { DataTestLoading } from './DataTestLoading';
import { OverwriteSetting } from '../OverwriteSetting';
import { useEnrichableObjectTypes } from '../EnrichableObjectTypesProvider';
import { UsageAlert } from '../Usage/UsageAlert';
import { BasePanel } from '../Panel/BasePanel';
import { PanelUsageEnrichment } from '../Panel/PanelUsageEnrichment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertiesHeading = ({
  isContactEnrichment
}) => {
  const {
    companyLabel,
    contactLabel
  } = useEnrichableObjectTypes();
  if (isContactEnrichment) return /*#__PURE__*/_jsx(Heading, {
    as: "h5",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataTest.matchRate.contacts.propertiesTitle",
      options: {
        objectType: contactLabel
      }
    })
  });
  return /*#__PURE__*/_jsx(Heading, {
    as: "h5",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataTest.matchRate.companies.propertiesTitle",
      options: {
        objectType: companyLabel
      }
    })
  });
};
export function DataTestPanelBody() {
  const {
    isContactEnrichment,
    properties,
    recordsIneligible,
    recordsEligible,
    recordsSelected,
    recordsEnrichable,
    shouldOverwrite,
    setShouldOverwrite
  } = useDataTest();
  const action = 'DATASET_ENRICHMENT';
  return /*#__PURE__*/_jsx(BasePanel.Body, {
    children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
      position: "relative",
      children: [/*#__PURE__*/_jsx(PanelHeader, {}), /*#__PURE__*/_jsxs(DataTestLoading, {
        children: [/*#__PURE__*/_jsx(LayoutBox, {
          paddingInline: "space-xl",
          children: /*#__PURE__*/_jsx(UsageAlert, {
            action: action,
            numberOfOperations: recordsEnrichable
          })
        }), /*#__PURE__*/_jsxs(DataTestError, {
          children: [/*#__PURE__*/_jsx(SectionMatchRate, {
            isContactEnrichment: isContactEnrichment,
            recordsEligible: recordsEligible,
            recordsEnrichable: recordsEnrichable,
            recordsIneligible: recordsIneligible,
            recordsSelected: recordsSelected
          }), /*#__PURE__*/_jsx(LayoutSpaceVertical, {
            paddingInline: "space-xl",
            children: /*#__PURE__*/_jsx(PanelUsageEnrichment, {
              numberOfOperations: recordsEnrichable,
              paddingInline: "space-xl"
            })
          }), /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
            gap: "space-md",
            children: [/*#__PURE__*/_jsxs(LayoutHorizontal, {
              justifyContent: "space-between",
              paddingInline: "space-xl",
              children: [/*#__PURE__*/_jsx(PropertiesHeading, {
                isContactEnrichment: isContactEnrichment
              }), /*#__PURE__*/_jsx(OverwriteSetting, {
                checked: shouldOverwrite,
                id: "datatest-overwrite-setting",
                onChange: setShouldOverwrite
              })]
            }), /*#__PURE__*/_jsx(MatchRatePropertiesGrid, {
              properties: properties
            })]
          })]
        })]
      })]
    })
  });
}